import { create } from "zustand";
import type { PerformanceMode } from "../types/astronomy";
import type { VisualizationScale } from "../types/astronomy";
import { TRUE_SCALE } from "../astronomy/units";

interface SettingsStore {
  scale: VisualizationScale;
  performanceMode: PerformanceMode;
  shadowsEnabled: boolean;
  language: "pt" | "en";
  setPerformanceMode: (mode: PerformanceMode) => void;
  setShadowsEnabled: (value: boolean) => void;
  setLanguage: (language: "pt" | "en") => void;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
  scale: TRUE_SCALE,
  performanceMode: "balanced",
  shadowsEnabled: false,
  language: "pt",
  setPerformanceMode: (mode) => set({ performanceMode: mode }),
  setShadowsEnabled: (value) => set({ shadowsEnabled: value }),
  setLanguage: (language) => set({ language }),
}));
